<template>
    <div>
        <b-modal title="Save Search" id="save-search-popup" modal-class="modal-w-lg">

            <form class="form form-modal">
                <div class="form__item">
                    <label class="form__label">Search Name</label>
                    <input v-model="name" class="form-control form-control--mid">
                </div>

                <div class="form__item">
                    <label class="form__label">Privacy</label>

                    <div class="input-radio mb-3">
                        <input id="pr1" type="radio" v-model="type" value="personal">
                        <label for="pr1">Only me</label>
                    </div>
                    <div class="input-radio">
                        <input id="pr2" type="radio" v-model="type" value="company">
                        <label for="pr2">Shared with company</label>
                    </div>
                </div>

                <div class="form__item row">
                    <div class="col-8">
                        <div class="input-checkbox">
                            <input id="auto-scouting" type="checkbox" v-model="enableAutoScout">
                            <label for="auto-scouting">Enable Auto-Scout</label>
                        </div>
                    </div>
                </div>

                <div class="form__item row">

                    <div class="col-8">

                        <template v-if="enableAutoScout">
                            <label class="form__label">Add New Matches For Tracker:</label>
                            <multiselect
                                v-model="trackers"
                                :options="trackersList"
                                :multiple="true"
                                select-label=""
                                deselect-label=""
                                placeholder="Type to search your trackers"
                                label="name"
                                track-by="name"
                                class="multiselect-mid selectbox selectbox-mid mb-3"
                            >
                            </multiselect>
                        </template>
                    </div>

                    <div class="col-4" v-if="stagesList.length">
                        <label class="form__label">Add To Stage:</label>
                        <multiselect
                            v-model="stage"
                            :options="stagesList"
                            select-label=""
                            deselect-label=""
                            label="name"
                            track-by="name"
                            class="multiselect-mid selectbox selectbox-mid mb-3"
                        >
                        </multiselect>
                    </div>
                </div>
            </form>

            <template #modal-footer>
                <b-button :disabled="!name.length" variant="primary" size="lg" @click="save">Save</b-button>
            </template>
        </b-modal>

        <b-modal title="Manage Saved Searches" id="manage-saved-searches-popup" size="md" ok-only ok-variant="secondary" ok-title="Close" hide-footer>

            <div v-for="(group, groupName) in list" :key="groupName">
                <label>{{groupName}}</label>

                <ul class="manage-list">
                    <li v-for="(item, index) in group" :key="index">
                        <p class="manage-list__title">{{list[groupName][index].name}}</p>

                        <a @click="openSave(item.id)" class="link-edit">Edit</a>
                        <a @click="deleteSearch(item.id)" class="link-remove">Delete</a>
                    </li>
                </ul>
            </div>
        </b-modal>

    </div>
</template>

<script>

import savedSearches from '@/services/saved-searches.service'
import trackers from '@/services/trackers.service'
import multiselect from "vue-multiselect";

export default {

    props: {
        rules: Array,
        savedSearchesList: Array,
        searchType: String,
    },

    components: {
        multiselect
    },

    data() {
        return {
            id: 0,
            name: '',
            type: 'personal',
            tracker_ids: [],
            stage_id: null,
            stage: null,
            enableAutoScout: false,

            trackers: [],

            trackersList: [],
            stagesList: [],

            list: {},

            notWatchTrackers: false,
        }
    },

    watch: {
        savedSearchesList() {
            let list = {}

            this.savedSearchesList.forEach(group => {
                list[group.group] = []

                group.items.forEach((item) => {
                    list[group.group].push({
                        id: item.id,
                        name: item.name,
                        newName: item.name,
                        editMode: false,
                    })
                })
            })

            this.list = list
        },

        enableAutoScout() {
            if (!this.enableAutoScout) {
                this.trackers = []
            }
        },

        trackers() {
            if (!this.notWatchTrackers) {
                this.tracker_ids = this.arrayHelper.arrayColumn(this.trackers, 'value')
                this.getStages()
            }
        },

        stage() {
            if (this.stage) {
                this.stage_id = this.stage.value
            }
            else {
                this.stage_id = null
            }
        }
    },

    mounted() {
        this.getTrackers()
    },

    methods: {
        openSave(id = 0) {
            this.id = 0
            this.name = ''
            this.type = 'personal'
            this.tracker_ids = []
            this.trackers = []
            this.stage_id = null
            this.stage = null
            this.enableAutoScout = false

            if (id) {
                savedSearches.getEdit(id).then(response => {
                    this.id = id
                    this.name = response.data.name
                    this.type = response.data.type
                    this.tracker_ids = response.data.tracker_ids

                    this.notWatchTrackers = true

                    response.data.tracker_ids.forEach(item => {
                        let index = this.arrayHelper.findIndexByColumnValue(this.trackersList, 'value', item)
                        if (index >= 0) {
                            this.trackers.push(this.trackersList[index])
                        }
                    })

                    if (response.data.tracker_ids.length) {
                        this.enableAutoScout = true
                    }

                    this.notWatchTrackers = false

                    if (response.data.stage_id) {
                        this.stage_id = response.data.stage_id
                    }

                    this.getStages()

                    this.$bvModal.show('save-search-popup')
                })
            }
            else {
                this.$bvModal.show('save-search-popup')
            }
        },

        save() {
            let data = {
                name: this.name,
                search_type: this.searchType,
                type: this.type,
                rules: this.rules,
                trackers: this.tracker_ids,
                stage: this.stage_id,
            }

            savedSearches.save(this.id, data).then(() => {
                this.$bvModal.hide('save-search-popup')
                this.$emit('saved-search-changed')
            })
        },

        getTrackers() {
            trackers.getList('internal').then(response => {
                this.trackersList = response.data
            })
        },

        getStages() {
            trackers.getStages(this.tracker_ids).then(response => {
                this.stagesList = response.data
                if (!this.stagesList.length) {
                    this.stage = null
                } else if (this.stage_id) {
                    let index = this.arrayHelper.findIndexByColumnValue(this.stagesList, 'value', this.stage_id)

                    if (index >= 0) {
                        this.stage = this.stagesList[index]
                    }
                }
            })
        },

        openManage() {
            this.$bvModal.show('manage-saved-searches-popup')
        },

        updateQuery(id) {
            savedSearches.updateQuery(id, this.rules).then(() => {
                this.$emit('saved-search-changed')
            })
        },

        deleteSearch(id) {
            if (confirm("Delete Search?")) {
                savedSearches.deleteSearch(id).then(() => {
                    this.$emit('saved-search-changed')
                })
            }
        }
    }
}
</script>